export default class MultiPaymentMinControl {
    constructor() {
        this.enableField = document.querySelector(
            `#woocommerce_vindi-pagamentos-multi-payment_enable_multipayment_min_control`
        );

        this.minValueField = document.querySelector(
            `#woocommerce_vindi-pagamentos-multi-payment_multipayment_min_amount`
        ).closest('tr');

        this.init();
    }

    init() {
        if (this.enableField) {
            this.toggleMinValueField();
            this.enableField.addEventListener("change", () => {
                this.toggleMinValueField();
            });
        }
    }

    toggleMinValueField() {
        const isEnabled = this.enableField.checked;
        this.minValueField.style.display = isEnabled ? 'table-row' : 'none';
    }
}